<div class="rd-container" *ngIf="!isLoading && role; else loadingTpl">
	<div class="panel rd-header-panel">
		<div class="rd-header">
			<div class="rd-title">
				<h2>{{ role.displayName || role.roleName }}</h2>
				<p *ngIf="role.description">{{ role.description }}</p>
				<div class="rd-header-meta">
					<span class="pill pill-sm" [class.pill-amber]="role.isSystemLevel" [class.pill-grey]="!role.isSystemLevel">
						{{ role.isSystemLevel ? 'System' : 'Business' }}
					</span>
					<span class="pill pill-sm pill-grey" aria-label="Role rank">Staff rank {{ role.staffRank ?? '—' }}</span>
					<span class="pill pill-sm pill-grey" aria-label="Total permissions for role">
						{{ selectedPermissionIds.size }} permissions
					</span>
				</div>
			</div>
			<ng-container *staffCan="'Platform.Roles.ManagePermissions'"><button type="button" class="act" (click)="onSave()" [disabled]="isSaving || loadFailed">
				{{ isSaving ? 'Saving…' : 'Review changes' }}
			</button></ng-container>
		</div>
	</div>

  <p *ngIf="loadFailed" class="note note-err" role="alert">Permissions could not be loaded. Reload before editing.</p>
  <p *ngIf="saveError" class="note note-err" role="alert">{{ saveError }}</p>
  <section *ngIf="showDiff" class="panel" role="alertdialog" aria-label="Confirm permission changes">
    <h3>Review changes for {{ role.displayName || role.roleName }}</h3>
    <p>These changes affect every user holding this role.</p>
    <h4>Grant</h4><ul><li *ngFor="let permission of addedPermissions">{{ permission.code }}</li></ul>
    <h4>Revoke</h4><ul><li *ngFor="let permission of removedPermissions">{{ permission.code }}</li></ul>
    <button class="act" (click)="confirmSave()" [disabled]="isSaving">Confirm changes</button>
    <button class="act-ghost" (click)="showDiff = false" [disabled]="isSaving">Cancel</button>
  </section>
	<div class="rd-permissions">
		<div class="rd-group" *ngFor="let group of permissionGroups">
			<h3>
				{{ group.category }}
				<span class="group-count">{{ getCheckedCountForGroup(group) }} / {{ group.permissions.length }}</span>
			</h3>
			<ul>
				<li *ngFor="let perm of group.permissions">
					<label>
						<ng-container *staffCan="'Platform.Roles.ManagePermissions'"><input
							type="checkbox"
              [disabled]="isSaving || loadFailed"
							[checked]="isPermissionChecked(perm.permissionId)"
							(change)="togglePermission(perm.permissionId, $event.target.checked)"
						/></ng-container>
						<span class="perm-name">{{ perm.name }}</span>
						<div class="perm-meta">
							<span class="perm-code mono">{{ perm.code }}</span>
							<span class="perm-desc" *ngIf="perm.description">{{ perm.description }}</span>
						</div>
					</label>
				</li>
			</ul>
		</div>
	</div>
</div>

<ng-template #loadingTpl>
	<div class="loading">Loading role details…</div>
</ng-template>
